'use strict';

export { default as EmployeeMealAppAllowances } from './employeeMealAppAllowances.container';
